// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Header----styles-module---wrapper---kdzQb","title":"src-components-Header----styles-module---title---1ODKG","logo":"src-components-Header----styles-module---logo---3SEpy","actions":"src-components-Header----styles-module---actions---3m9Hg","link":"src-components-Header----styles-module---link---Zl1H9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.module.css
// module id = 366
// module chunks = 114276838955818